import { useState, useEffect } from 'react';

export function useDaySize(
  config = [
    { media: '(min-width: 769.1px)', daySize: 38 },
    { media: '(max-width: 769px)', daySize: 52 },
    { media: '(max-width: 400px)', daySize: 45 },
    { media: '(max-width: 350px)', daySize: 38 },
  ]
) {
  const initialState = 38;
  const [daySize, setDaySize] = useState(initialState);
  useEffect(() => {
    const listener = () => {
      config.forEach(({ media, daySize }) => {
        if (window.matchMedia(media).matches) {
          setDaySize(daySize);
        }
      });
    };
    window.addEventListener('resize', listener);
    listener();
    return () => window.removeEventListener('resize', listener);
  }, [config]);
  return daySize;
}
